module.exports = __webpack_public_path__ + "media/img/cer-icon-5d7f1713.png";